import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { GCP_SIZE_GUIDE_CLASSES } from "./constants";

export const GcpSizeGuideContainer = styled(Box)(({ theme }) => {
  const { BREAKPOINT_TABLET } = getFormatMedia(theme);

  return {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(3),
    [`& .${GCP_SIZE_GUIDE_CLASSES.title}`]: {
      ...theme.typography.h5,
      paddingLeft: theme.spacing(5),
      marginBottom: theme.spacing(2.75),
      [BREAKPOINT_TABLET]: {
        ...theme.typography.h4,
        paddingLeft: theme.spacing(0),
        marginBottom: theme.spacing(3),
      },
    },
    [`& .${GCP_SIZE_GUIDE_CLASSES.description}`]: {
      paddingRight: theme.spacing(4),
      marginBottom: theme.spacing(2.75),
      [BREAKPOINT_TABLET]: {
        paddingRight: theme.spacing(0),
      },
    },
    [`& .${GCP_SIZE_GUIDE_CLASSES.table}`]: {
      "&:last-child": {
        marginTop: theme.spacing(3),
      },
    },
  };
});
